import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';

const SessionContext = createContext();

export function SessionProvider({ children }) {
  // ✅ Rehydrate synchronously before first render
  const [session, setSession] = useState(() => {
    const saved = localStorage.getItem('currentSession');
    console.log('[SessionProvider] Rehydrating synchronously. Saved value:', saved);
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed?.id && parsed?.startedAt) {
          console.log('[SessionProvider] Session restored from localStorage:', parsed);
          return parsed;
        } else {
          console.warn('[SessionProvider] Invalid session object:', parsed);
        }
      } catch (err) {
        console.warn('[SessionProvider] Failed to parse saved session:', err);
      }
    }
    return null;
  });

  // ✅ Keep localStorage in sync with state changes
  useEffect(() => {
    console.log('[SessionProvider] Session updated:', session);
    if (session) {
      localStorage.setItem('currentSession', JSON.stringify(session));
      console.log('[SessionProvider] Session saved to localStorage');
    } else {
      localStorage.removeItem('currentSession');
      console.log('[SessionProvider] Session removed from localStorage');
    }
  }, [session]);

  return (
    <SessionContext.Provider value={{ session, setSession }}>
      {children}
    </SessionContext.Provider>
  );
}

export const useSession = () => useContext(SessionContext);
